import SDIcon from './SDIcon'

const IconCarbonIndustry = (props) => (
  <SDIcon title='Industry' {...props}>
    <path
    d='M29.53,6.15a1,1,0,0,0-1,0L20,10.38V7a1,1,0,0,0-1.45-.89L10,10.38V3A1,1,0,0,0,9,2H3A1,1,0,0,0,2,3V28H30V7A1,1,0,0,0,29.53,6.15ZM22,26H18V19h4Zm6,0H24V18a1,1,0,0,0-1-1H17a1,1,0,0,0-1,1v8H4V4H8v9.62l10-5v5l10-5Z'
    transform='translate(0 0)'
    />
  </SDIcon>
)

export default IconCarbonIndustry
